import * as PIXI from "pixi.js";
import { AbstractPanelLayout } from "./AbstractPanelLayout";
/**
 * GridLayout.ts
 */
export class GridLayout extends AbstractPanelLayout {
    constructor(rows, columns, horizontalSpacing = 0, verticalSpacing = 0, columnOffset = 0, rowOffset = 0) {
        super();
        this.rows = rows;
        this.columns = columns;
        this.horizontalSpacing = horizontalSpacing;
        this.verticalSpacing = verticalSpacing;
        this.columnOffset = columnOffset;
        this.rowOffset = rowOffset;
    }
    equals(other) {
        return super.equals(other) &&
            (this.rows === other.rows) &&
            (this.columns === other.columns) &&
            (this.horizontalSpacing === other.horizontalSpacing) &&
            (this.verticalSpacing === other.verticalSpacing) &&
            (this.columnOffset === other.columnOffset) &&
            (this.rowOffset === other.rowOffset);
    }
    apply(children) {
        let x = 0;
        let y = 0;
        let y_offset = 0;
        let child;
        let size;
        let index = 0;
        for (let row = 0; row < this.rows; row++) {
            x = (typeof this.rowOffset === "function" ? this.rowOffset(row) : (row * this.rowOffset));
            y = y_offset;
            for (let column = 0; column < this.columns; column++) {
                child = children[index++];
                if (child) {
                    y += (typeof this.columnOffset === "function" ? this.columnOffset(column) : (column * this.columnOffset));
                    size = this.getChildSize(child);
                    this.addChild(child, new PIXI.Point(x, y));
                    x += size.x + (typeof this.horizontalSpacing === "function" ? this.horizontalSpacing(column) : this.horizontalSpacing);
                }
            }
            if (size) {
                y_offset += size.y + (typeof this.verticalSpacing === "function" ? this.verticalSpacing(row) : this.verticalSpacing);
            }
        }
    }
    clone() {
        return new GridLayout(this.rows, this.columns, this.horizontalSpacing, this.verticalSpacing);
    }
    getRows() {
        return this.rows;
    }
    getColumns() {
        return this.columns;
    }
    getHorizontalSpacing() {
        return this.horizontalSpacing;
    }
    getVerticalSpacing() {
        return this.verticalSpacing;
    }
}
//# sourceMappingURL=GridLayout.js.map